import React from "react";
import CacheBuster from "react-cache-buster";
import { ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";
import "../node_modules/react-toastify/dist/ReactToastify.css";
import packageInfo from "../package.json";
import "./App.scss";
import ErrorBoundary from "./components/ErrorBoundary";
import Loader from "./components/Loader";
import Routes from "./components/routes";

function App() {
  return (
    <ErrorBoundary>
      <CacheBuster currentVersion={packageInfo.version} isEnabled={true} isVerboseMode={false} loadingComponent={<Loader />} metaFileDirectory={"."}>
        <React.Fragment>
          <ReactTooltip />
          <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss pauseOnHover limit={1} />
          <Routes />
        </React.Fragment>
      </CacheBuster>
    </ErrorBoundary>
  );
}

export default App;
